import { useEffect, useRef, useState } from 'react';
import { XIcon } from 'lucide-react';
import { business } from '../data/site';
type SpecialsTextDialogProps = {
  open: boolean;
  onClose: () => void;
};
export function SpecialsTextDialog({
  open,
  onClose
}: SpecialsTextDialogProps) {
  const [phone, setPhone] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);
  const closeRef = useRef<HTMLButtonElement>(null);
  const previouslyFocused = useRef<HTMLElement | null>(null);
  useEffect(() => {
    if (!open) return;
    previouslyFocused.current = document.activeElement as HTMLElement;
    closeRef.current?.focus();
    const {
      overflow
    } = document.body.style;
    document.body.style.overflow = 'hidden';
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        onClose();
        return;
      }
      if (event.key !== 'Tab' || !panelRef.current) return;
      const focusables = panelRef.current.querySelectorAll<HTMLElement>('a[href], button:not([disabled]), input:not([disabled])');
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = overflow;
      previouslyFocused.current?.focus();
    };
  }, [open, onClose]);
  useEffect(() => {
    if (!open) {
      setSubmitted(false);
      setPhone('');
    }
  }, [open]);
  if (!open) return null;
  return <div className="fixed inset-0 z-[60] flex items-end justify-center sm:items-center" data-id="element-209" data-mp="1d4cbj4o76ji6">
      <div className="absolute inset-0 bg-ink/60" onClick={onClose} aria-hidden="true" data-id="element-210" data-mp="186kjmanjyxdz" />
      <div ref={panelRef} role="dialog" aria-modal="true" aria-labelledby="specials-text-title" className="relative m-4 w-full max-w-[460px] rounded-card bg-white p-6" data-id="element-211" data-mp="388k2269sokp4">
        <button ref={closeRef} type="button" onClick={onClose} aria-label="Close" className="absolute right-3 top-3 flex h-11 w-11 items-center justify-center rounded-btn text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-212" data-mp="3hzy8yz42smsa">
          <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-213" data-mp="2ua3u6c074o5e" />
        </button>

        <h2 id="specials-text-title" className="pr-12 text-[24px] font-semibold leading-8 text-ink" data-id="element-214" data-mp="2ya49rzz175e1">
          Get Occasional Specials by Text
        </h2>

        {submitted ? <p className="mt-3 text-body text-ink/80" data-id="element-215" data-mp="dlgc895xt2bi">
            Thanks — we have your number. You can also call or text us any time at {business.phone}.
          </p> : <>
            <p className="mt-3 text-body text-ink/80" data-id="element-216" data-mp="sohoeqvjsiyh">
              Add your mobile number and Pegasus will text you when specials and in-stock
              opportunities come up. Message and data rates may apply. Reply STOP to end.
            </p>
            <form className="mt-5" onSubmit={event => {
          event.preventDefault();
          setSubmitted(true);
        }} data-id="element-217" data-mp="iwbvnexh1xi8">
              <label htmlFor="specials-phone" className="block text-[15px] font-bold text-ink" data-id="element-218" data-mp="9yrwcbj66ba9">
                Mobile number
              </label>
              <input id="specials-phone" name="phone" type="tel" inputMode="tel" autoComplete="tel" required value={phone} onChange={event => setPhone(event.target.value)} placeholder="517-000-0000" className="mt-2 h-12 w-full rounded-btn border border-ink/25 px-3 text-[16px] text-ink transition-colors duration-150 ease-out focus:border-pegasus-blue" data-id="element-219" data-mp="3w459rfkehpsp" />
              <div className="mt-4 flex flex-wrap gap-3" data-id="element-220" data-mp="22cormppomwn2">
                <button type="submit" className="inline-flex min-h-[48px] items-center rounded-btn bg-pegasus-magenta px-5 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-[#bb2f83]" data-id="element-221" data-mp="1oeic2polpjc7">
                  Sign Me Up
                </button>
                <button type="button" onClick={onClose} className="inline-flex min-h-[48px] items-center rounded-btn border border-ink/25 px-5 text-[16px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-222" data-mp="1jff4axh8kz0j">
                  Not Now
                </button>
              </div>
            </form>
          </>}
      </div>
    </div>;
}